// VERIFIE 25/10/2024 !!!!! Section non vérifié plus bas

// ||
// ||
// \/

import { Prod } from "../interfaces";
import { ProdIndex } from "../interfaces/ProdIndex.interface";
import { ObjectId } from "../types";
import {  ip } from "./../utils/setup";

const PRODUCT_API = `${ip}/api/Prods`;

// GET

export async function getProduct(_id: ObjectId): Promise<Prod> {
    const response = await fetch(`${PRODUCT_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la réception du produit");
  }
}

export async function getProdsNoHiden() {
  try {
      const response = await fetch(PRODUCT_API + "/noHiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getProdsHiden() {
  try {
      const response = await fetch(PRODUCT_API + "/hiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

export async function getProductsByChant(
  _id: ObjectId | undefined
): Promise<Prod[] | undefined> {
  if (_id != undefined) {
      const response = await fetch(`${PRODUCT_API}/byChant?idChant=${_id}`, {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error("Erreur du serveur lors de la réception du produit");
    }
  } else return undefined;
}

// POST

export async function createProduct(newProduct: Partial<Prod>): Promise<Prod> {
  const response = await fetch(PRODUCT_API, {
    method: "POST",
    headers: {
        "content-type": "application/json",
        
      },
      credentials: "include" ,
    body: JSON.stringify(newProduct),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouveau produit");
  }
}

export async function IndexProdAPI(indexprod: ProdIndex) {
  const { globalError, ...restProduct } = indexprod;
  const response = await fetch(PRODUCT_API + "/index", {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(restProduct),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error(" Erreur lors de l'indexation des prix");
  }
}

//PUT

export async function updateProduct(updateProduct: Prod) {
  const { globalError, ...restProduct } = updateProduct;
  const response = await fetch(`${PRODUCT_API}/${restProduct.idProd}`, {
      method: "PUT",
      credentials: "include" ,
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify(restProduct),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition du produit");
  }
}

// DELETE

export async function deleteProduct(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${PRODUCT_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression du produit ");
  }
}

// SUPPRIMER COMMENTAIRE APRES L ENTIERE VERIFICATION

// NON VERIFIE !!!!!

// ||
// ||
// \/

//export async function getProducts(): Promise<Prod[]> {
//  const response = await fetch(PRODUCT_API);
//  if (response.ok) {
//    const body: Prod[] = await response.json();
//    return body;
//  } else {
//    return response.json();
//  }
//}

// export async function deleteProductFact(_id: ObjectId) {
//   const response = await fetch(PRODUCT_API + "/deleteProdFact/" + _id, {
//     method: "DELETE",
//   });
//   if (response.ok) {
//     return _id;
//   } else {
//     throw new Error("Erreur lors de la suppression du produits ");
//   }
// }


